import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Manager } from 'actions/actionTypes';
import * as actions from 'actions/auth/manager';

import { callTokenRefresh, callNoticePopup } from 'network/apis/auth/manager';

function* tokenRefreshRequestSaga() {
    try {
        const manager = yield select((state) => state.manager);

        const response = yield call(callTokenRefresh, manager.token.refreshToken);

        yield put(actions.tokenRefreshSuccess(response.data));
    } catch (error) {
        // 재발급 실패 시 로그아웃 처리
        yield put(actions.signOut());
    }
}

function* noticePopupRequestSaga() {
    try {
        const response = yield call(callNoticePopup);

        yield put(actions.loadNoticePopupRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadNoticePopupRequestFailure(error.message));
    }
}

// Manager Sagas
export default function* root() {
    yield all([takeLatest(Manager.TOKEN_REFRESH_REQUEST, tokenRefreshRequestSaga), takeLatest(Manager.LOAD_NOTICE_POPUP_REQUEST, noticePopupRequestSaga)]);
}
